import type { ListSummary } from '@todo/shared';
import { api, get, post, patch } from './client';
import type { ApiSuccess } from '@todo/shared';

/** /api/lists - personal lists. Every mutation returns the refreshed set. */
export const listApi = {
  /** With taskId, each list carries containsTask for that task. */
  all(taskId?: string): Promise<ListSummary[]> {
    return get<ListSummary[]>('/lists', taskId ? { taskId } : undefined);
  },

  create(name: string): Promise<ListSummary[]> {
    return post<ListSummary[]>('/lists', { name });
  },

  rename(id: string, name: string): Promise<ListSummary[]> {
    return patch<ListSummary[]>(`/lists/${id}`, { name });
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/lists/${id}`);
  },

  async addTask(id: string, taskId: string): Promise<ListSummary[]> {
    const res = await api.put<ApiSuccess<ListSummary[]>>(`/lists/${id}/tasks/${taskId}`);
    return res.data.data;
  },

  async removeTask(id: string, taskId: string): Promise<ListSummary[]> {
    const res = await api.delete<ApiSuccess<ListSummary[]>>(`/lists/${id}/tasks/${taskId}`);
    return res.data.data;
  },
};
